import styles from './ContactForm.module.scss';

const ExtraInfoForm = ({
	formData,
	handleMultipleCheckbox,
	handleBooleanToggle,
	authentication,
	handlePasswordChange,
}: any) => {
	return (
		<>
			<h2 className={styles['section-title']}>Final Section</h2>

			<label htmlFor="preferredContactMethod">
				Please advise what your preferred method of contact for this enquiry is. *
			</label>
			<div className={styles['checkbox-group']}>
				<label>
					<input
						type="checkbox"
						name="preferredContactMethod"
						value="Email"
						checked={formData.preferredContactMethod.includes('Email')}
						onChange={handleMultipleCheckbox}
					/>
					Email
				</label>
				<label>
					<input
						type="checkbox"
						name="preferredContactMethod"
						value="Phone"
						checked={formData.preferredContactMethod.includes('Phone')}
						onChange={handleMultipleCheckbox}
					/>
					Phone
				</label>
			</div>

			<label>
				Would you like us to share your results with {formData.referringClinician || 'your clinic'}
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.shareResultsNordClinic === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('shareResultsNordClinic', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.shareResultsNordClinic === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('shareResultsNordClinic', false)}
				>
					No
				</button>
			</div>

			<label>
				I hereby consent for my imaging report and images to be sent to Sirkka Health to be shared
				with my referring clinic/clinicians.
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentImageReportSirkka === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentImageReportSirkka', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentImageReportSirkka === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentImageReportSirkka', false)}
				>
					No
				</button>
			</div>

			<label>
				I hereby consent for completely anonymised medical data related to these tests to be used
				for medical research purposes.
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentMedicalResearch === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentMedicalResearch', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.consentMedicalResearch === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('consentMedicalResearch', false)}
				>
					No
				</button>
			</div>

			<label>
				Have you registered on Sirkka Health's website (
				<a href="https://sirkkahealth.com/login">
					<u>https://sirkkahealth.com/login</u>
				</a>
				)?{' '}
				<b>
					<u>We will need you to register in order to process your appointments.</u>
				</b>{' '}
				Once you validate your ID (UK passport/driving license), you can access test/scan results in
				your portal.{' '}
			</label>
			<div className={styles['toggle-buttons']}>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.isRegisteredSirkkaWebsite === true ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('isRegisteredSirkkaWebsite', true)}
				>
					Yes
				</button>
				<button
					type="button"
					className={`${styles['toggle-button']} ${
						formData.isRegisteredSirkkaWebsite === false ? styles['active'] : ''
					}`}
					onClick={() => handleBooleanToggle('isRegisteredSirkkaWebsite', false)}
				>
					No
				</button>
			</div>

			{formData.isRegisteredSirkkaWebsite === false && (
				<>
					<div className={styles['form-group']}>
						<label htmlFor="password">Create a password *</label>
						<input
							type="password"
							id="password"
							name="password"
							value={authentication.password || ''}
							onChange={handlePasswordChange}
							required
							className={styles['form-select']}
						/>
					</div>

					<div className={styles['form-group']}>
						<label htmlFor="confirmPassword">Confirm password *</label>
						<input
							type="password"
							id="confirmPassword"
							name="confirmPassword"
							value={authentication.confirmPassword || ''}
							onChange={handlePasswordChange}
							required
							className={styles['form-select']}
						/>
					</div>
				</>
			)}
		</>
	);
};

export default ExtraInfoForm;
